import React from 'react';
import { createPortal } from 'react-dom';
import moment from 'moment-timezone';
import { Flame } from 'lucide-react';

import { POP_CLASS, useHoverPop } from '../workspace/DeskKit';

// They came in hot (Nic 2026-10-23): a small flame after the client's name,
// for good. Hover (or tap) says who sent them and when. It never says
// whether the specialist picked up; "Call them back" does that.
export const hotSeatLine = (seat) => {
  if (!seat) return '';
  const from = seat.byName ? `Hot Transfer from ${seat.byName}` : 'Hot Transfer';
  return seat.at ? `${from} · ${moment(seat.at).format('MMM D')}` : from;
};

const HotSeatMark = ({ seat, size = 13 }) => {
  const { open, setOpen, show, hide, timer, btnRef, popRef, style } = useHoverPop(220);
  if (!seat) return null;
  const line = hotSeatLine(seat);
  return (
    <>
      <button
        ref={btnRef}
        type="button"
        aria-label={line}
        aria-expanded={open}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        onClick={(e) => {
          e.stopPropagation();
          clearTimeout(timer.current);
          setOpen((o) => !o);
        }}
        onKeyDown={(e) => e.stopPropagation()}
        className="inline-flex shrink-0 self-center rounded-full text-orange-500 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/60 dark:text-orange-400"
      >
        <Flame size={size} strokeWidth={2.4} />
      </button>
      {open && style
        ? createPortal(
            <div
              ref={popRef}
              role="tooltip"
              onMouseEnter={show}
              onMouseLeave={hide}
              onClick={(e) => e.stopPropagation()}
              style={{ ...style, overflowY: 'visible', maxHeight: 'none' }}
              className={POP_CLASS}
            >
              <div className="flex items-center gap-1.5 text-[12.5px] font-semibold text-slate-700 dark:text-slate-200">
                <Flame size={13} className="shrink-0 text-orange-500" />
                {line}
              </div>
            </div>,
            document.body,
          )
        : null}
    </>
  );
};

export default HotSeatMark;
